import { UserRole } from '@depanneo/types'
import { requiredRoles } from '@/shared/utils/require-roles'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/settings/settings'
)({
  beforeLoad() {
    requiredRoles([UserRole.ADMIN])
  },
})
